import { useState } from 'react';

interface ModalState {
  isOpen: boolean;
  title: string;
  message: string;
  type: 'info' | 'success' | 'warning' | 'error';
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  showCancel?: boolean;
}

export const useModal = () => {
  const [modalState, setModalState] = useState<ModalState>({
    isOpen: false,
    title: '',
    message: '',
    type: 'info'
  });

  const showModal = (config: Omit<ModalState, 'isOpen'>) => {
    setModalState({
      ...config,
      isOpen: true
    });
  };

  const hideModal = () => {
    setModalState(prev => ({
      ...prev,
      isOpen: false
    }));
  };

  const showInfo = (title: string, message: string) => {
    showModal({ title, message, type: 'info' });
  };

  const showSuccess = (title: string, message: string) => {
    showModal({ title, message, type: 'success' });
  };

  const showWarning = (title: string, message: string) => {
    showModal({ title, message, type: 'warning' });
  };

  const showError = (title: string, message: string) => {
    showModal({ title, message, type: 'error' });
  };

  const showConfirm = (
    title: string, 
    message: string, 
    onConfirm: () => void,
    confirmText = 'Confirmer',
    cancelText = 'Annuler'
  ) => {
    showModal({
      title,
      message,
      type: 'warning',
      confirmText,
      cancelText,
      onConfirm,
      showCancel: true
    });
  };

  const showDangerConfirm = (
    title: string, 
    message: string, 
    onConfirm: () => void,
    confirmText = 'Supprimer',
    cancelText = 'Annuler'
  ) => {
    showModal({
      title,
      message,
      type: 'error',
      confirmText,
      cancelText,
      onConfirm,
      showCancel: true
    });
  };

  return {
    modalState,
    showModal,
    hideModal,
    showInfo,
    showSuccess,
    showWarning,
    showError,
    showConfirm,
    showDangerConfirm
  };
};

